import { useEffect, useState } from 'react';

/**
 * Seconds since `running` became true. Planning calls take tens of seconds; a
 * ticking count says it is working, where a bare spinner for 40 seconds reads
 * as hung.
 */
export function useElapsed(running: boolean): number {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!running) return;
    setElapsed(0);
    const t = setInterval(() => setElapsed((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, [running]);
  return elapsed;
}
